import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteSavedDocumentCommentArgs,
  BackendSavedDocumentComment,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteSavedDocumentComment($commentId: ID!) {
    deleteSavedDocumentComment(commentId: $commentId) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteSavedDocumentCommentArgs;
type Result = Pick<BackendSavedDocumentComment, 'id'>;

export const deleteSavedDocumentComment = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
